import {
  Box,
  Text,
  Flex,
  Progress,
  VStack,
  HStack,
  Badge,
} from '@chakra-ui/react';

export const CreditUsageCard = ({
  isPro = false,
  creditsUsed = 0,
  creditLimit = 0,
  extraCredits = 0,
  totalCredits = 0,
  expiryDate = '',
}) => {
  const isOverLimit = creditsUsed > totalCredits;
  const cappedUsed = isOverLimit ? totalCredits : creditsUsed;
  const usagePercent = totalCredits === 0 ? 0 : ((cappedUsed / totalCredits) * 100);
  const overageAmount = Math.round((creditsUsed - totalCredits) * 100) / 100;

  return (
    <>
      <Flex alignItems="center" mb={6}>
        <Text fontSize="lg" fontWeight="semibold" mr={2}>
          Account Credit Summary
        </Text>
        {
          creditsUsed === 100 && extraCredits === 0 ?
          <Badge colorScheme='red' variant='solid' >All Credits Exhausted</Badge> : null
        }
      </Flex>
      <Box bg="white" p={6} rounded="xl" border="1px" borderColor="gray.200">

        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          gap={6}
        >
          <Box flex="1">
            <HStack spacing={2} align="baseline">
              <Text fontSize="4xl" fontWeight="bold" color={isOverLimit ? 'red.600' : 'gray.800'}>{creditLimit - creditsUsed}</Text>
              <Text color="gray.500" fontSize="md">/ 100</Text>
              {extraCredits > 0 && (
                <Text fontSize="4xl" fontWeight="bold" color="orange.400">
                  <Box as="span" fontWeight="bold" color="gray.700" mr={1}>+</Box>{extraCredits}
                </Text>
              )}
            </HStack>

            {/* <Progress
              mt={4}
              borderRadius="md"
              colorScheme="purple"
              value={usagePercent}
              height="6px"
              bg="gray.200"
            /> */}
            <Text fontSize="xs" color={isOverLimit ? 'red.600' : 'gray.600'} mt={1}>
              {isOverLimit
                ? `You have exceeded your credit limit by ${overageAmount} credits`
                : `Total credits available`}
            </Text>
          </Box>

          {isPro && <VStack flex="1" align="center" spacing={1}>
            <Text fontSize="2xl" fontWeight="bold" color="blue.700">{creditLimit - creditsUsed}</Text>
            <Text fontSize="md" color="gray.700">Available Monthly Credits</Text>
            {
              creditLimit - creditsUsed <= 0 ? null :
              <Text fontSize="sm" color="gray.500">
                Expires on {expiryDate}
              </Text>
            }
          </VStack>}
          <VStack flex="1" align="center" spacing={1}>
            <Text fontSize="2xl" fontWeight="bold" color="orange.400">{extraCredits}</Text>
            <Text fontSize="md" color="gray.700">Available Extra Credits</Text>
            <Text fontSize="sm" color="gray.500">
              No expiration
            </Text>
          </VStack>
        </Flex>
      </Box>
    </>
  );
};
